module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "cummins_logo_black.997e665a.png";